import { Component, OnInit } from "@angular/core";
import { ICellComponent } from "../../../modules/records/models/i-cell-component";
import { RatingCol } from "../../table-col-configs/rating-col";
import { MyUtils } from "src/app/services/my-utils.service";

@Component({
  selector: "app-rating",
  templateUrl: "./rating.component.html",
  styleUrls: ["./rating.component.scss"],
})
export class RatingComponent<T extends object>
  implements OnInit, ICellComponent<T>
{
  data!: string;
  tenstarRating: boolean = false;
  thumbs_up_down = "   ../../../../assets/svg/thumbs/thumbs_up_down.svg"
  thumbs_up = "../../../../assets/svg/thumbs/thumbs_up.svg"
  thumbs_down = "../../../../assets/svg/thumbs/thumbs_down.svg"
  rateThumb: string = '';
  constructor(public utils: MyUtils) { }

  ngOnInit(): void {}

  setComponentData(el: T, colConfig: RatingCol<T>) {
    const data = colConfig.getElementData(el);
    this.parseData(data);
  }

  parseData(data: string) {
    const splitData = data?.split('#') ?? [];
    this.data = splitData.length == 1 ? splitData[0] : splitData[1];
    if (this.data && !!parseInt(this.data)) {
      const rating = parseInt(this.data);
      this.tenstarRating = true;
      if (rating > 8) {
        this.rateThumb = this.thumbs_up;
      } else if (rating > 6) {
        this.rateThumb = this.thumbs_up_down;
      } else {
        this.rateThumb = this.thumbs_down;
      }
    } else {
      let translation = this.utils.traslatei18n(splitData[0]);
      
      console.log(translation,data,this.data,splitData)
    }
  }

  // control(data: any){
  //   if(!parseInt(data)){
  //     this.dataString = data;
  //   }
  //  return this.dataString;
  // }

}
